export class ExportCostData400Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return ExportCostData400Response.attributeTypeMap;
    }
    constructor() {
    }
}
